import {Directive, Input} from '@angular/core';

interface GenericTemplateContext<TItem> {
  $implicit: TItem;
  [key: string]: any;
}

@Directive({
  selector: `ng-template[castTo]`,
  standalone: true
})
export class CastTemplateDirective <T> {
  @Input('castTo') data!: T;

  static ngTemplateContextGuard<TContextItem extends object>(
    dir: CastTemplateDirective<TContextItem>,
    ctx: unknown
  ): ctx is GenericTemplateContext<TContextItem> {
    return true;
  }
}
